import { render, staticRenderFns } from "./LiveBookingsDoughnut.vue?vue&type=template&id=028b517a"
import script from "./LiveBookingsDoughnut.vue?vue&type=script&lang=ts"
export * from "./LiveBookingsDoughnut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports